import React from 'react';
import { cleanCategoryHeader } from 'utils';

export default Component => {
    const withCleanCategoryHeader = props => {
        return (
            <Component
                {...props}
                cleanCategoryHeader={cleanCategoryHeader() || (() => {})}
            />
        );
    };

    withCleanCategoryHeader.displayName = `withCleanCategoryHeader(${Component.name})`;

    return withCleanCategoryHeader;
};
